import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';


export default function AgentCodeDialog(props) {
 
  const handleBack=()=>{
    sessionStorage.removeItem('isReloaded');
    window.location.href="/"
  }


  return (
    <React.Fragment>

      <Dialog
        open={props.open}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            props.handleSubmit()
          },
        }}
        fullWidth
        maxWidth={"xs"}
      >
        <DialogTitle sx={{fontSize:'15px'}}>Enter your mobile number</DialogTitle>
        
          <CloseIcon onClick={()=>handleBack()}  sx={{position:'absolute',top:8,right:8,cursor:'pointer'}} />
        
        <DialogContent sx={{mt:'0px',paddingBlock:0}}>

          <TextField
            autoFocus
            
            margin="dense"
            id="name"
            error={props.code&&!/^\d{10}$/.test(props.code)}
            value={props.code?props.code:''}
            name="email"
            label="Mobile Number"
            type="text"
            fullWidth
            variant="filled"
            color='secondary'
            InputLabelProps={{
              sx: {
                fontSize: '1rem', 
              },
            }}
            onChange={(e)=>{
              const value = e.target.value.replace(/\s+/g, '').trim();
              const isValid = /^\d*$/.test(value); // Check if the value contains only digits
            
              if (isValid && value.length <= 10) {
                props.setCode(value); // Update the code if the value is valid and within the length limit
              }    
              
            }}
          />
          <p  style={{visibility:props.code&&!/^\d{10}$/.test(props.code)?'visible':'hidden',color:'red',marginBottom:'0px'}}>Please enter the valid mobile number</p>
        </DialogContent>

        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
          {
            props.loading? (
              <Button disabled={true} variant='contained' color='secondary' sx={{borderRadius:'5px'}}>Loading...</Button>
            ) : (
              <Button disabled={props.code&&!/^\d{10}$/.test(props.code)} variant='contained' color='secondary' sx={{borderRadius:'5px'}} type="submit">Submit</Button>
            )
          }
          {/* <Button  disabled={props.code&&!/^\d{10}$/.test(props.code)} variant='contained' color='secondary' sx={{borderRadius:'5px'}} type="submit">Submit</Button> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
